const JWT_TOKEN = "JWT_TOKEN";

function getToken() {
  return localStorage.getItem(JWT_TOKEN);
}

function saveToken(token) {
  localStorage.setItem(JWT_TOKEN, token);
}

function removeToken() {
  localStorage.removeItem(JWT_TOKEN);
}

export { getToken, saveToken, removeToken };
